module.exports = __webpack_public_path__ + "static/img/002.2df27b9c.png";